import { fileUrl } from "../../lib/api";
import { SizeGuide } from "./SizeGuide";

const HEX = {
  "bleu nuit": "#2B3F7A", "beige naturel": "#C8AB8A", "gris anthracite": "#5E6064", "blanc": "#F3EEE4", "vert sauge": "#A9B98A",
  "lavande": "#B896AE", "café noir": "#5A2E22", "café clair": "#6E5A4A", "vieux rose": "#D9A3AE", "tan naturel": "#C8A98A",
  "gris argenté": "#B9BBBE", "bleu roi": "#2F4DB3", "rouge": "#B3262E", "jaune": "#E7C34A", "vert forêt": "#2F4A35",
  "gris marbré": "conic-gradient(#2E3036, #9EA2A8, #44474E, #C9CCD1, #2E3036)",
};
export const splitName = (n) => (n.includes(" · ") ? n.split(" · ") : [null, n]);

const Swatch = ({ color, img, active, soldOut, onClick }) => (
  <button type="button" data-testid={`swatch-${color}`} title={color} aria-label={color} onClick={onClick}
    className={`relative w-10 h-10 rounded-full p-[3px] border transition-[border-color,transform] duration-200 hover:scale-105 ${active ? "border-[#1C1A17]" : "border-black/15"} ${soldOut ? "opacity-40" : ""}`}>
    <span className="block w-full h-full rounded-full border border-black/25 bg-cover bg-center"
      style={img ? { backgroundImage: `url(${fileUrl(img, 300)})` } : { background: HEX[color.toLowerCase()] || "#D8D2C8" }} />
    {soldOut && <span className="absolute inset-0 m-auto w-[2px] h-10 bg-[#8A8378] rotate-45" />}
  </button>
);

export function VariantPicker({ p, variant, onPick }) {
  const v = p.variants.find((x) => x.id === variant);
  const [color, size] = v ? splitName(v.name) : [null, null];
  const colors = [...new Set(p.variants.map((x) => splitName(x.name)[0]).filter(Boolean))];
  if (!colors.length) {
    return (
      <div className="flex flex-wrap gap-2">
        {p.variants.map((x) => <button key={x.id} data-testid={`variant-${x.id}`} disabled={!x.in_stock} onClick={() => onPick(x)}
          className={`px-4 py-2 border text-sm transition-colors ${variant === x.id ? "border-[#1C1A17]" : "border-black/10"} disabled:opacity-30 disabled:line-through`}>{x.name}</button>)}
      </div>
    );
  }
  const sizes = [...new Set(p.variants.map((x) => splitName(x.name)[1]))];
  const find = (c, s) => p.variants.find((x) => x.name === `${c} · ${s}`);
  const imgFor = (c) => Object.keys(p.image_colors || {}).find((u) => p.image_colors[u] === c);
  const pickColor = (c) => onPick(find(c, size)?.in_stock ? find(c, size) : p.variants.find((x) => x.in_stock && splitName(x.name)[0] === c) || find(c, size) || p.variants.find((x) => splitName(x.name)[0] === c));
  return (
    <div className="space-y-6">
      <div>
        <div className="label-xs mb-3">Couleur <span className="normal-case tracking-normal text-muted-foreground ml-2" data-testid="selected-color">{color}</span></div>
        <div className="flex flex-wrap gap-2">
          {colors.map((c) => <Swatch key={c} color={c} img={imgFor(c)} active={c === color} soldOut={!p.variants.some((x) => x.in_stock && splitName(x.name)[0] === c)} onClick={() => pickColor(c)} />)}
        </div>
      </div>
      <div>
        <div className="label-xs mb-3">Format</div>
        <div className="flex flex-wrap gap-2">
          {sizes.map((s) => {
            const x = find(color, s);
            return <button key={s} data-testid={`size-${s}`} disabled={!x?.in_stock} onClick={() => onPick(x)}
              className={`px-4 py-2 border text-sm transition-colors ${s === size ? "border-[#1C1A17]" : "border-black/10"} disabled:opacity-30 disabled:line-through`}>{s}</button>;
          })}
        </div>
        <SizeGuide sizes={sizes} />
      </div>
    </div>
  );
}
